import { CompanyRole, SecurityLevel } from "@/__generated__/graphql";
import { isDefaultVendor, NullableCurrentUser } from "./userContext";
import { RESTRICTED_TIER_LEVEL } from "./constants";

export interface Project {
  id: string;
  securityLevel: SecurityLevel;
  sourceProject: null | {
    id: string;
  };
}

export const isSubcontractedVendor = (
  role: CompanyRole,
  project: { sourceProject?: { id: string } | null },
) => {
  return role === CompanyRole.Vendor && !!project.sourceProject;
};

export const UserPassesSecurityConstrain = (
  role: CompanyRole,
  project: {
    securityLevel: SecurityLevel;
    sourceProject?: { id: string } | null;
  },
  user?: NullableCurrentUser,
) => {
  // security constrain check is only for default vendors and subcontractors
  if (role === CompanyRole.Vendor) {
    if (isDefaultVendor(role, user) || isSubcontractedVendor(role, project)) {
      return !RESTRICTED_TIER_LEVEL.includes(project.securityLevel);
    }
    return true;
  }

  return !RESTRICTED_TIER_LEVEL.includes(project.securityLevel);
};

export const UserEnabledForOfflineAccess = (
  role: CompanyRole,
  project: {
    securityLevel: SecurityLevel;
    sourceProject?: { id: string } | null;
  },
  user?: NullableCurrentUser,
) => {
  return !!(
    role === CompanyRole.Vendor &&
    isSubcontractedVendor(role, project) &&
    project.securityLevel === SecurityLevel.Tier_2 &&
    user?.office?.company.profile.authorizedForOfflineAccess
  );
};
